import { render, staticRenderFns } from "./EditionTranslations_SubPanel_Links.vue?vue&type=template&id=059da38c"
import script from "./EditionTranslations_SubPanel_Links.vue?vue&type=script&lang=js"
export * from "./EditionTranslations_SubPanel_Links.vue?vue&type=script&lang=js"
import style0 from "./EditionTranslations_SubPanel_Links.vue?vue&type=style&index=0&id=059da38c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports